import { Field, TextInput } from '@hotjar/hotsauce';
import type { Label } from '@hotjar/feedback/domain/Surveys/Questions/SurveyQuestion';
import { useTranslation } from 'react-i18next';

export interface ScaleLabelsProps {
  labels: Label[];
  onChange: (labels: Label[]) => void;
  validate: boolean;
}

export const ScaleLabels = ({
  labels,
  onChange,
  validate,
}: ScaleLabelsProps): JSX.Element | null => {
  const { t } = useTranslation('feedback');

  if (!labels) {
    return null;
  }

  const handleLabelChange = (value: string, index: number) => {
    const newLabels = [...labels];
    newLabels[index].text = value;
    onChange(newLabels);
  };

  const fields = [
    {
      id: 'low-label',
      label: t('wizard.section.questions.low-label'),
    },
    {
      id: 'high-label',
      label: t('wizard.section.questions.high-label'),
    },
  ];

  return (
    <>
      {fields.map(({ id, label }, index) => (
        <Field
          key={id}
          inputId={id}
          labelText={label}
          isInvalid={validate && labels[index].text.length === 0}
          size="l"
        >
          <TextInput
            id={id}
            placeholder=""
            value={labels[index].text}
            onChange={(evt) => handleLabelChange(evt.target.value, index)}
            isInvalid={validate && labels[index].text.length === 0}
          />
        </Field>
      ))}
    </>
  );
};
